/**
 * @desc POD文件提交
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inMaster.uploadPODFile.Params, options?: any) {
  return updateResponse(
    http(URL + `/inMaster/uploadPODFile`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
